import { ControllerClassicIcon } from './ControllerClassicIcon';

/**
 * author: Austin Andrews
 * id 2D97B0F0-9662-4323-8F5B-0677507461EE
 * name controller-classic
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/controller-classic.svg
 * tags
 * - Gaming / RPG 
 */
export const GamepadClassicIcon = ControllerClassicIcon;
export default GamepadClassicIcon